<script setup lang="ts">
import { onMounted } from 'vue'

const emit = defineEmits<{
  (e: 'backButton', backUrl: string|null): void
}>()

onMounted(() => {
  emit('backButton', '/')
})

function errorOnFunction() {
  throw new Error('Test error on function event')
}

async function errorOnAsyncFunction() {
    let message = await asyncTask()
    throw new Error('Error after async await')
}

async function asyncTask(): Promise<string> {
    return "unused message";
}
</script>

<template>
  <h2>Setup your life here</h2>

  <p><input type="checkbox">Check this</p>

  <button @click="errorOnFunction()" >Error on event</button>
  <button @click="errorOnFunction">Error on function</button>
  <button @click="errorOnAsyncFunction">Error on function async</button>
</template>

<style scoped>
h2, p {
  text-align: center;
}
</style>
